module.exports = __webpack_public_path__ + "img/partner_logo5.dd54e0c7.png";